import { useQuery } from "@tanstack/react-query";
import { apiClient, ApiError } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import type { CurrentOrganization } from "@/types/api/user";
import { useCurrentUser } from "./useCurrentUser";

/**
 * Active organization for the logged-in user.
 * Skips fetch until `/users/me` has a user (avoids 401 on guest routes).
 * Non-401 failures toast only (see queryClient); login still seeds org via useSignIn.
 */
export function useCurrentOrganization() {
  const { data: user } = useCurrentUser();

  return useQuery({
    queryKey: queryKeys.auth.organization(),
    queryFn: () => apiClient.get<CurrentOrganization>("/auth/organization"),
    enabled: !!user,
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.statusCode === 401) && failureCount < 1,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: (query) => (query.state.data ? 5 * 60 * 1000 : false),
  });
}
